import React from "react";
import { useForm } from "react-hook-form";
import RadioFieldset from "../../common/forms/components/RadioFieldset";
import useFormActions from "../useFormActions";
import StepWrapper from "./StepWrapper";
import { subscriptionStepProps } from "../../common/types/subscription";

export default function Step1({
	formStep,
	subtitle,
	title,
}: subscriptionStepProps) {
	const { onUpdateField, onUpdateForm } = useFormActions();
	const { control, handleSubmit, setFocus, setValue } = useForm({
		defaultValues: {
			lookingFor: "trial",
		},
	});

	const fieldsetDefinition = [
		{
			inputLabel: "What are you trying to achieve with this trial?",
			radioKey: "trial",
			radioLabel:
				"A free 14-day trial to ch-aviation online subscription.",
			radioTitle: "Trial",
		},
		{
			inputLabel:
				"Please tell us as much as possible about your data project:",
			radioKey: "consultation",
			radioLabel: "A free consultation on the ch-aviation data feeds.",
			radioTitle: "Consultation",
		},
		{
			checkboxChoices: [
				{ key: "onlineSubscription", label: "Online Subscription" },
				{ key: "dataFeed", label: "Data Feed" },
			],
			radioKey: "buy",
			radioLabel: "I would like to buy ch-aviation Data & News.",
			radioTitle: "Buy",
		},
	];

	return (
		<StepWrapper
			formStep={formStep}
			onSubmit={handleSubmit(onUpdateForm)}
			title={title}
			subtitle={subtitle}
		>
			<RadioFieldset
				control={control}
				criterionKey="lookingFor"
				fieldsetDefinition={fieldsetDefinition}
				onUpdateField={onUpdateField}
				setFocus={setFocus}
				setValue={setValue}
			/>
		</StepWrapper>
	);
}
